// extracted by mini-css-extract-plugin
export var modal = "_fe-0";